// src/components/S3.js
import { useState, useEffect, memo } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useAWS } from '../aws-context';
import listObjects from './listObjects'

let dateOptions = {
  hourCycle: 'h24',
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  weekday: 'short',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
}

// memo evita re-render cuando solo cambia email (las props item, index, link no cambian)
let Item = memo(function Item(props) {
  let { address } = useParams()
  let label = props.item.Key.split('/').find(p => p.includes('@')) || props.item.Key || ''
  let link = [props.link, address || label].filter(Boolean).join('/')

  return (
    <div className="flex items-center gap-2 leading-none">
      <a href={props.item.url} target="_blank" rel="noreferrer" className="leading-none font-mono text-blue-600">
        {props.index.toString().padStart(4, '0')}
      </a>
      <div> - </div>
      <span className="leading-none text-gray-900 font-mono">
        {props.item.LastModified.toLocaleString('es-AR', dateOptions)}
      </span>
      <div> - </div>
      <Link to={link} className="leading-none text-gray-500">
        {label}
      </Link>
    </div>
  )
})

let Loader = () => (
  <div className="flex items-center gap-2 text-gray-500 text-sm py-4">
    <span className="inline-block w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
    Cargando…
  </div>
);

const PAGE_SIZE = 1000;

let Deliveries = () => {
  let navigate = useNavigate()

  let { address, bucket } = useParams()
  let [objects, setObjects] = useState([])
  let [page, setPage] = useState(0)
  let [loading, setLoading] = useState(false)
  let [email, setEmail] = useState(address || '')

  let { credentials } = useAWS();

  let handleKeyDown = event => {
    if (event.key === 'Enter') {
      navigate(`/s3/${bucket}/emails/${email}`);
    }
  }

  useEffect(() => {
    if (!bucket) return
    setObjects([])
    setPage(0)
    setLoading(true)
    let prefix = ['emails', address].filter(Boolean).join('/')
    let payload = { ...credentials, prefix, bucket, showAll: !!email }
    listObjects(payload)
      .then(objects => {
        setObjects(objects)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [address, bucket, credentials])

  let totalPages = Math.max(1, Math.ceil(objects.length / PAGE_SIZE))
  let pageObjects = objects.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE)
  let globalStart = page * PAGE_SIZE

  return (
    <div className="flex flex-col gap-y-2 py-4 px-4 bg-white h-screen overflow-y-auto">
      <div className="flex items-center gap-1">
        <div className="text-gray-500 text-sm">emails</div>
        <div className="text-gray-500 text-xs">/</div>
        <Link to={`/s3/${bucket}/emails`} className="text-blue-500 text-sm">
          {bucket}
        </Link>
        {address && (
          <>
            <div className="text-gray-500 text-xs">/</div>
            <div className="text-gray-500 text-sm">{address}</div>
          </>
        )}
      </div>
      <div>
        <div className="bg-gray-100 rounded flex">
          <input
            value={email}
            name="aws_s3_prefix"
            id="aws_s3_prefix"
            onChange={e => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            type="email"
            placeholder="Direccion de email a buscar"
            className="grow px-3 py-2 bg-transparent text-sm"
          />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {loading ? (
          <Loader />
        ) : (
          <>
            {!!address && (
              <div className="flex items-center gap-2 flex-wrap text-sm text-gray-600">
                <span>{objects.length} objetos</span>
                <span className="text-gray-400">|</span>
                <button
                  type="button"
                  disabled={page <= 0}
                  onClick={() => setPage(p => Math.max(0, p - 1))}
                  className="text-blue-600 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  Anterior
                </button>
                <span>Página {page + 1} de {totalPages}</span>
                <button
                  type="button"
                  disabled={page >= totalPages - 1}
                  onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
                  className="text-blue-600 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  Siguiente
                </button>
              </div>
            )}
            {pageObjects.map((item, i) => (
              <Item
                item={item}
                index={globalStart + i + 1}
                link={['/s3', bucket, 'emails'].join('/')}
                key={item.Key}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Deliveries;
